// @ts-check
import { hasFloor } from './player.js';
import { querySolids } from './geometry.js';
import { BOTS } from './tuning.js';
/** Gravity and solid contacts shared by patrols and physical rewards.
 * @param {import('./types.js').Rect & {vx:number,vy:number}} actor @param {import('./types.js').Level} level @param {number} dt
 */
export function moveActor(actor, level, dt) {
  const oldX = actor.x;
  actor.x += actor.vx * dt;
  for (const solid of querySolids(level, Math.min(oldX, actor.x), Math.max(oldX, actor.x) + actor.width)) {
    if (actor.y >= solid.y + solid.height - 0.001 || actor.y + actor.height <= solid.y + 0.001) continue;
    if (actor.vx > 0 && oldX + actor.width <= solid.x + 0.001 && actor.x + actor.width > solid.x) {
      actor.x = solid.x - actor.width; actor.vx = -Math.abs(actor.vx);
    } else if (actor.vx < 0 && oldX >= solid.x + solid.width - 0.001 && actor.x < solid.x + solid.width) {
      actor.x = solid.x + solid.width; actor.vx = Math.abs(actor.vx);
    }
  }
  if (actor.x < 0 || actor.x + actor.width > level.width) { actor.x = Math.max(0, Math.min(level.width - actor.width, actor.x)); actor.vx *= -1; }
  const oldY = actor.y;
  actor.y += actor.vy * dt - 0.5 * BOTS.gravity * dt * dt; actor.vy -= BOTS.gravity * dt;
  let landing = oldY >= 0 && actor.y <= 0 && hasFloor(actor.x, actor.width, level) ? 0 : null;
  let ceiling = Infinity;
  for (const solid of querySolids(level, actor.x, actor.x + actor.width)) {
    if (actor.x + actor.width <= solid.x || actor.x >= solid.x + solid.width) continue;
    const top = solid.y + solid.height;
    if (actor.vy <= 0 && oldY >= top - 0.001 && actor.y <= top) landing = Math.max(landing ?? -Infinity, top);
    if (actor.vy > 0 && oldY + actor.height <= solid.y + 0.001 && actor.y + actor.height >= solid.y) ceiling = Math.min(ceiling, solid.y);
  }
  if (ceiling < Infinity) { actor.y = ceiling - actor.height; actor.vy = 0; }
  if (landing !== null) { actor.y = landing; actor.vy = 0; return true; }
  return false;
}
